import styled from "styled-components";
import { INPUTS } from "@etiquette-ui/colors";
import FormSection from 'containers/Form/FormSection';

 export const CustomFormSection = styled(FormSection)`
  @media( max-width: 768px ){
    padding: 0px;
    margin: 0px;
    margin-top: 22px;
  }
`;

 export const Switch = styled.div`
  display: flex;
  max-width: 350px;
  margin: 10px 0px;
  align-items: center;
  .label {
    margin-left: 7px;    
  }
  .switch-button {
    margin-left: 0px;
  }

  &.bottom-option {
    margin-top: 22px;
  }

  &.--secondary {
    margin: 0px 0px 3px;
    .switch-button {
      margin-left: -2px;
    }
    .label {
      margin-left: 5px;
      font-size: 15px;
    }
  }

  @media (min-width: 768px) {
    &.--secondary {
      .switch-button {
        transform: scale(.8);
      }
      .label {
        margin-left: 0px;
        font-size: 13px;
      }
    }
  }
`;

 export const RangeContainer = styled.div`
  gap: 10px;
  max-width: 100%;
  
  .row {
    margin-bottom: -5px;
    &.--disabled {
      display: none;
    }
  }

  @media ( min-width: 768px ) {
    .row {
      gap: 10px;
      display: flex;
      position: relative;

      &.--disabled {
        display: block;
        &:after {
          content: '';
          inset: 0px;
          position: absolute;
          background-color: rgba(255 255 255 / 50%);
        }
        &:hover {
          cursor: not-allowed;
        }
      }
    }
  }
`;

 export const Rule = styled.div`
  gap: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: end;
  position: relative;
  margin-bottom: 20px;
  padding-bottom: 15px;

  .switches {
    margin-top: 10px;
  }

  .days-selector {
    margin-right: 25px;
  }

  &:after {
    content: "";
    bottom: -5px;
    left: 5%;
    right: 5%;
    max-width: 90%;
    position: absolute;
    border-top: 2px solid ${INPUTS};
  }

  @media( min-width: 768px ){
    margin-bottom: 15px;
    padding-bottom: 0px;

    &:after{
      display: none;
    }
    .switches {
      margin-top: auto;
      margin-left: 0px;
      margin-left: -20px;
    }
  }
`;

 export const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
    @media( max-width: 768px ) {
      justify-content: center;
    }
`;